module.exports = __webpack_public_path__ + "src/assets/models/spectrophotometer/spectrophotometer_apparat.fbx";